/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */

export type SortInFn = typeof SortInFn[keyof typeof SortInFn];


export const SortInFn = {
  none: 'none',
  left: 'left',
  right: 'right',
  substr: 'substr',
  pattern: 'pattern',
} as const;
